export default {
  bucket: 'tc_uploader_test',
  pipelineUrl: 'https://pipeline-api.stg.hummingbirdtech.com',
};
